import { BaseApi } from './base'

class AuthorizationApi extends BaseApi {
  constructor() {
    const baseURL = process.env.GATSBY_AUTHORIZATION_HOST
    super(baseURL)
  }

  getResourceAllowed(accessToken = null) {
    return this.instance.get('authorized-resources', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
  }
}

export { AuthorizationApi }
